// src/store/employeeSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiGet } from "services/api";
const BACKEND_URL = import.meta.env.VITE_API_URL;
// ✅ Async thunk to fetch employees
export const fetchEmployees = createAsyncThunk(
  "employees/fetchEmployees",
  async (_, { rejectWithValue }) => {
    try {
      // ✅ Get token (depends on how you store it)
      const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken'); 
      // or sessionStorage.getItem("token")

      const res = await apiGet("employee/getall")
      // , {
      //   headers: {
      //     Authorization: `Bearer ${token}`, // ✅ send JWT
      //   },
      // }
    // );

      return res?.data?.data; // { total_count, last_31_days_count, employees }
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const employeeSlice = createSlice({
  name: "employees",
  initialState: {
    employees: [],
    total_count: 0,
    last_31_days_count: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployees.fulfilled, (state, action) => {
        state.loading = false;
        state.total_count = action.payload.total_count;
        state.last_31_days_count = action.payload.last_31_days_count;
        state.employees = action.payload.employees;
      })
      .addCase(fetchEmployees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default employeeSlice.reducer;
